import { render, staticRenderFns } from "./MaintenanceOverlay.vue?vue&type=template&id=6f56b84b&scoped=true"
import script from "./MaintenanceOverlay.vue?vue&type=script&lang=js"
export * from "./MaintenanceOverlay.vue?vue&type=script&lang=js"
import style0 from "./MaintenanceOverlay.vue?vue&type=style&index=0&id=6f56b84b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f56b84b",
  null
  
)

export default component.exports